import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { Promotion } from '@core/models/promotion.model';
import { PromotionMessage } from '@core/models/promotion-message.model';

@Injectable()
export class PromotionMessageEntityService extends EntityCollectionServiceBase<PromotionMessage> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('PromotionMessages', serviceElementsFactory);
  }
}
